import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../components/Admin/AdminLayout';
import './AdminForm.css';

const AddProduct = () => {
  const [form, setForm] = useState({ name: '', description: '', category: '', featured: false});
  const [imageFile, setImageFile] = useState(null);
  const navigate = useNavigate();

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleFileChange = e => setImageFile(e.target.files[0]);

  const handleSubmit = async e => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('name', form.name);
    formData.append('description', form.description);
    formData.append('category', form.category);
    formData.append('featured', form.featured);
    if (imageFile) formData.append('image', imageFile);

    await fetch('https://infuse-backend.onrender.com/api/products', {
      method: 'POST',
      body: formData,
      credentials: 'include'
    });

    navigate('/admin/dashboard');
  };

  return (
    <AdminLayout>
      <div className="admin-form-container">
        <h2>Add New Product</h2>
        <form className="admin-form" onSubmit={handleSubmit} encType="multipart/form-data">
          <label>Name:</label>
          <input type="text" name="name" value={form.name} onChange={handleChange} required />

          <label>Category:</label>
          <input type="text" name="category" value={form.category} onChange={handleChange} />

          <label>Image:</label>
          <input type="file" accept="image/*" onChange={handleFileChange} required />

          <label>Description:</label>
          <textarea name="description" rows="4" value={form.description} onChange={handleChange} />

          <div className="form-checkbox">
            <input 
              type="checkbox" 
              id="featured" 
              name="featured" 
              checked={form.featured || false}
              onChange={(e) => setForm({...form, featured: e.target.checked})}
            />
            <label htmlFor="featured">Featured Product</label>
          </div>

          <button type="submit">Add Product</button>
        </form>
      </div>
    </AdminLayout>
  );
};

export default AddProduct;